import { Tooltip, Typography } from "@mui/material"
import { Author } from "./CommonInterfaces"

interface AuthorListProps {
    authors: Author[]
}

function AuthorList({ authors }: AuthorListProps) {
    return <>
        {
            authors.slice(0, 5).map((author, authorIndex) =>
            (<Tooltip key={authorIndex} placement="top" {...(author.institutions.length > 0 ? { title: author.institutions[0].displayName + ", " + author.institutions[0].countryCode } : { title: 'No institution available' })}>
                <Typography component="span" gutterBottom variant="body2">{authorIndex === 0 ? author.rawAuthorName : ", " + author.rawAuthorName}</Typography>
            </Tooltip>
            )
            )}
            {authors.length > 5 && <Typography component="span" gutterBottom variant="body2"> et al.</Typography>}
    </>
}

export default AuthorList